import apolloClient from "../apolloClient";
import { GET_ADDRESS } from "./graphql";

class AddressService {
	async list() {
		const { data } = await apolloClient.query({
			query: GET_ADDRESS,
		});

		return data.myAddress.nodes;
	}
}

export default new AddressService();
